import {
  ListBoxItem as AriaListBoxItem,
  Collection,
  Header,
  ListBoxItemProps,
  Section,
  SectionProps,
  composeRenderProps,
} from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { focusRing } from "./utils";

export function DropdownItem(props: ListBoxItemProps) {
  const textValue =
    props.textValue ||
    (typeof props.children === "string" ? props.children : undefined);
  return (
    <AriaListBoxItem
      {...props}
      textValue={textValue}
      // className="group flex select-none items-center gap-4 px-7 py-3 text-sm text-white outline outline-0 focus:text-theme-primary"
      className={(renderProps) =>
        twMerge(
          focusRing(renderProps),
          "hover:bg-theme-on-background-hover flex h-11 cursor-pointer items-center gap-x-3 rounded-md px-4 font-medium text-nowrap transition-[background-color] duration-200",
          renderProps.selectionMode === "single" &&
            renderProps.isSelected &&
            "text-theme-active",
          composeRenderProps(
            props.className,
            (className) => className,
          )(renderProps),
        )
      }
    >
      {(renderProps) => (
        <div className="truncate">
          {composeRenderProps(
            props.children,
            (children) => children,
          )(renderProps)}
        </div>
      )}
    </AriaListBoxItem>
  );
}

export interface DropdownSectionProps<T> extends SectionProps<T> {
  title?: string;
}

export function DropdownSection<T extends object>(
  props: DropdownSectionProps<T>,
) {
  return (
    <Section className="after:block after:h-[5px] after:content-[''] first:-mt-[5px]">
      <Header className="sticky -top-[5px] z-10 -mx-1 -mt-px truncate border-y bg-gray-100/60 px-4 py-1 text-sm font-semibold text-gray-500 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 [&+*]:mt-1">
        {props.title}
      </Header>
      <Collection items={props.items}>{props.children}</Collection>
    </Section>
  );
}
